export { default as Container } from './container.js';
export { default as Row } from './row.js';
export { default as Col } from './col.js';
import React, { useState, useEffect } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import './styledConfig-9b5d3732.js';

const setToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};
const getFromSessionStorage = key => {
  const value = sessionStorage.getItem(key);
  if (value) return JSON.parse(value);
  return undefined;
};

const useTheme = () => {
  const allthemes = getFromSessionStorage('all-themes');
  const [theme, setTheme] = useState(allthemes === null || allthemes === void 0 ? void 0 : allthemes.themes.orange);
  const [themeLoaded, setThemeLoaded] = useState(false);
  const setThemeMode = mode => {
    setToSessionStorage('theme', mode);
    setTheme(mode);
  };
  useEffect(() => {
    const localTheme = getFromSessionStorage('theme');
    localTheme ? setThemeMode(localTheme) : setThemeMode(allthemes === null || allthemes === void 0 ? void 0 : allthemes.themes.orange);
    setThemeLoaded(true);
  }, []);
  return {
    theme,
    themeLoaded,
    setThemeMode
  };
};

const primaTheme = {
  backgroundColor: "#333333",
  textColor: "#000000",
  primary: "#77ccdd",
  themes: {
    orange: {
      id: "T_001",
      name: "Orange",
      colors: {
        backgroundColor: "#333333",
        primary: "#77ccdd",
        body: "#333333",
        textColor: "#000000",
        focusBorderColor: "rgba(255, 79, 0, 0.2)",
        primary: {
          background: "#ff4f00",
          color: "#FFFFFF"
        },
        secundary: {
          backgroundLight: "#FFF6EB",
          color: "#FFFFFF"
        },
        button: {
          primary: {
            color: "#FFFFFF",
            background: "#ff4f00",
            mainColor: 'var(--orangeColorMain)',
            activeColor: 'var(--orangeColorMainActive)'
          },
          secundary: {
            color: "var(--orangeColorMain)",
            mainColor: 'var(--orangeColorMain)',
            activeColor: 'rgba(255, 79, 0, 0.06)'
          },
          terciary: {
            color: "var(--greenColor)",
            mainColor: 'var(--greenColor)',
            activeColor: 'rgba(0, 164, 153, 0.06);'
          },
          quaternary: {
            color: "#696158",
            mainColor: 'rgba(105, 97, 88, 0.3)',
            activeColor: '#F7F7F7'
          }
        },
        select: {
          primary: {
            color: "#ff4f00",
            borderColor: "#ff4f00",
            arrow: {
              down: "#ff4f00",
              up: "#ff4f00"
            },
            hover: "linear-gradient(to top, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)) #ff4f00"
          }
        },
        text: {
          color: "rgba(105, 97, 88, 0.6)",
          fontSize: "18px"
        }
      },
      font: ""
    },
    green: {
      id: "T_002",
      name: "Green",
      colors: {
        backgroundColor: "#333333",
        textColor: "#000000",
        primary: "#77ccdd",
        body: "#333333",
        focusBorderColor: "none",
        primary: {
          background: "#00ae99",
          color: "#FFFFFF"
        },
        secundary: {
          backgroundLight: "rgba(0, 174, 153, 0.1)",
          color: "#FFFFFF"
        },
        button: {
          primary: {
            color: "#FFFFFF",
            background: "#00ae99",
            mainColor: 'var(--greenColor)',
            activeColor: '#059F8D'
          },
          secundary: {
            color: 'var(--greenColor)',
            mainColor: 'var(--greenColor)',
            activeColor: 'rgba(0, 164, 153, 0.06)'
          },
          terciary: {
            color: "var(--greenColor)",
            mainColor: 'var(--greenColor)',
            activeColor: 'rgba(0, 164, 153, 0.06);'
          },
          quaternary: {
            color: "#696158",
            mainColor: 'rgba(105, 97, 88, 0.3)',
            activeColor: '#F7F7F7'
          }
        },
        select: {
          primary: {
            color: "#00ae99",
            borderColor: "#00ae99",
            arrow: {
              down: "#00ae99",
              up: "#00ae99"
            },
            hover: "linear-gradient(to top, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)) #00ae99"
          }
        },
        text: {
          color: "rgba(105, 97, 88, 0.6)",
          fontSize: "18px"
        }
      },
      font: ""
    },
    purple: {
      id: "T_003",
      name: "Purple",
      colors: {
        backgroundColor: "#8A65DA",
        textColor: "#000000",
        primary: "#8A65DA",
        body: "#333333",
        focusBorderColor: "none",
        primary: {
          background: "#8A65DA",
          color: "#FFFFFF"
        },
        secundary: {
          backgroundLight: "#F6F3FC",
          color: "#FFFFFF"
        },
        button: {
          primary: {
            color: "#FFFFFF",
            background: "#8A65DA",
            mainColor: '#8A65DA',
            activeColor: '#7850CF'
          },
          secundary: {
            mainColor: '#8A65DA',
            color: '#8A65DA',
            activeColor: '#F6F3FC'
          },
          terciary: {
            color: "var(--greenColor)",
            mainColor: 'var(--greenColor)',
            activeColor: 'rgba(0, 164, 153, 0.06);'
          },
          quaternary: {
            color: "#696158",
            mainColor: 'rgba(105, 97, 88, 0.3)',
            activeColor: '#F7F7F7'
          }
        },
        select: {
          primary: {
            color: "#8A65DA",
            borderColor: "#8A65DA",
            arrow: {
              down: "#8A65DA",
              up: "#8A65DA"
            },
            hover: "linear-gradient(to top, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)) #8A65DA"
          }
        },
        text: {
          color: "rgba(105, 97, 88, 0.6)",
          fontSize: "18px"
        },
        input: {
          color: "#8A65DA",
          borderColor: "#8A65DA",
          arrow: {
            down: "#8A65DA",
            up: "#8A65DA"
          },
          hover: "linear-gradient(to top, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)) #8A65DA"
        }
      },
      font: ""
    },
    lightOrange: {
      id: "T_004",
      name: "lightOrange",
      colors: {
        backgroundColor: "#FF8A00",
        textColor: "#000000",
        primary: "#FF8A00",
        body: "#333333",
        focusBorderColor: "none",
        primary: {
          background: "#FF8A00",
          color: "#FFFFFF"
        },
        secundary: {
          backgroundLight: "#FFF6EB",
          color: "#FFFFFF"
        },
        button: {
          primary: {
            color: "#FFFFFF",
            background: "#FF8A00",
            mainColor: '#FF8A00',
            activeColor: '#e37a00'
          },
          secundary: {
            color: '#FF8A00',
            mainColor: '#FF8A00',
            activeColor: '#FFF1E2'
          },
          terciary: {
            color: "var(--greenColor)",
            mainColor: 'var(--greenColor)',
            activeColor: 'rgba(0, 164, 153, 0.06);'
          },
          quaternary: {
            color: "#696158",
            mainColor: 'rgba(105, 97, 88, 0.3)',
            activeColor: '#F7F7F7'
          }
        },
        select: {
          primary: {
            color: "#FF8A00",
            borderColor: "#FF8A00",
            arrow: {
              down: "#FF8A00",
              up: "#FF8A00"
            },
            hover: "linear-gradient(to top, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)) #8A65DA"
          }
        },
        text: {
          color: "rgba(105, 97, 88, 0.6)",
          fontSize: "18px"
        },
        input: {
          color: "#FF8A00",
          borderColor: "#FF8A00",
          arrow: {
            down: "#FF8A00",
            up: "#FF8A00"
          },
          hover: "linear-gradient(to top, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)) #8A65DA"
        }
      },
      font: ""
    }
  }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$5 = ":root{\n    --blackColor: #000000;\n    --grayColorBorder: #E8E8E8;\n    --grayColorComponents: #F9F9FB;\n    --grayColorHover: #F4F4F4;\n    --grayColorDisabled: #BBBBBB;\n    --grayColorCard: #F7F7F7;\n    --grayColorText: #696158;\n    --grayColorCardDashed: #D7D9D9;\n    --grayColorLineDashed: #BABABA;\n    --grayColorStep: #A29D98;\n    --greenColor: #00A499;\n    --greenColorBalance: #00AE99;\n    --greenColorHover: #059F8D;\n    --greenColorSelectCard: #EEFBF9;\n    --orangeColorHover: #EA4800;\n    --orangeColorMain: #FF4F00;\n    --orangeColorMainActive: #F04C02;\n    --redColorError: #FF4646;\n    --tooltipColor: rgb(105, 97, 88);\n    --whiteColorBase: #FFFFFF;\n    --placeholderColor: #9D9994;\n    --yellowBoldColor: #FFCD00;\n    --colorGrayBorder: #E8E8E8;\n\n    /* based on (page 1) from https://www.figma.com/file/IjFItcQc1dVmZ0UY8ZDT6w/Experiencia-%7C-Externos-%7C-Gu%C3%ADa-de-estilos?node-id=2755%3A3207 */\n    --blueColor: #002D74;\n    --orangeColor200: #FF9565;\n    --orangeColor300: #FFE4D9;\n    --yellowColor: #FFD380;\n    --redColorMain: #FFF2F2;\n    --beigeColorMain: #FFF6EB;\n    --grayColor200: #AAA9A9;\n    --grayColor300: #ECECEC;\n    --grayColorBackground: #F6F6F7;\n}\n";
styleInject(css_248z$5);

var css_248z$4 = "/* normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers.\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Render the `main` element consistently in IE.\n */\n\nmain {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * Remove the gray background on active links in IE 10.\n */\n\na {\n  background-color: transparent;\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57-\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10.\n */\n\nimg {\n  border-style: none;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the default vertical scrollbar in IE 10+.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10.\n * 2. Remove the padding in IE 10.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in Edge, IE 10+, and Firefox.\n */\n\ndetails {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Misc\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10+.\n */\n\ntemplate {\n  display: none;\n}\n\n/**\n * Add the correct display in IE 10.\n */\n\n[hidden] {\n  display: none;\n}\n";
styleInject(css_248z$4);

var css_248z$3 = "*,\n::after,\n::before {\n    box-sizing: border-box;\n}\n\n* {\n    padding: 0;\n    margin: 0;\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n}\n\nbutton {\n    background-color: transparent;\n    color: inherit;\n    border-width: 0;\n    padding: 0;\n    cursor: pointer;\n}\n\nfigure {\n    margin: 0;\n}\n\ninput::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n    margin: 0;\n}\n\ndd,\nol,\nul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 0;\n    font-size: inherit;\n    font-weight: inherit;\n}\n\np {\n    margin: 0;\n}\n\ncite {\n    font-style: normal;\n}\n\nfieldset {\n    border-width: 0;\n    padding: 0;\n    margin: 0;\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow: hidden;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n";
styleInject(css_248z$3);

var css_248z$2 = "/**\n * HERE YOU CAN PUT ONLINE GLOBAL STYLE FOR APP\n **/\n\nhtml {\n    font-size: 16px; /*for using REM units*/\n    overflow: auto;\n    background-color: var(--grayColorCard);\n}\n\nbody {\n    font-family: 'Calibri', sans-serif;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.3;\n    color: #222;\n}\n\nimg {\n    max-width: 100%\n}\n\nselect:disabled {\n    background-color: var(--grayColorComponents)\n}\n\ninput:disabled {\n    background: var(--grayColorComponents)\n}";
styleInject(css_248z$2);

var css_248z$1 = ".fade-in {\n    animation: fadeIn ease 1.2s;\n    -webkit-animation: fadeIn ease 1.2s;\n    -moz-animation: fadeIn ease 1.2s;\n    -o-animation: fadeIn ease 1.2s;\n    -ms-animation: fadeIn ease 1.2s;\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n@-moz-keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n@-webkit-keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n@-o-keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n@-ms-keyframes fadeIn {\n    0% {\n        opacity: 0\n    }\n    100% {\n        opacity: 1\n    }\n}\n\n\n.fade-out {\n    display: none !important;\n    animation: fadeOut ease 1.2s;\n    -webkit-animation: fadeOut ease 1.2s;\n    -moz-animation: fadeOut ease 1.2s;\n    -o-animation: fadeOut ease 1.2s;\n    -ms-animation: fadeOut ease 1.2s;\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n@-moz-keyframes fadeOut {\n    0% {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n@-webkit-keyframes fadeOut {\n    0% {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n@-o-keyframes fadeOut {\n    0% {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n@-ms-keyframes fadeOut {\n    0% {\n        opacity: 1\n    }\n    100% {\n        opacity: 0\n    }\n}\n\n\n.set-transition {\n    -webkit-transition: all .25s ease;\n    -o-transition: all .25s ease;\n    -moz-transition: all .25s ease;\n    transition: all .25s ease;\n}\n.shadow-hover:hover {\n    -webkit-transform: translateY(-4px) scale(1.02);\n    -moz-transform: translateY(-4px) scale(1.02);\n    -ms-transform: translateY(-4px) scale(1.02);\n    -o-transform: translateY(-4px) scale(1.02);\n    transform: translateY(-4px) scale(1.02);\n    -webkit-box-shadow: 0 5px 10px rgba(62, 57, 107, .2);\n    box-shadow: 0 5px 10px rgba(62, 57, 107, .2);\n    z-index: 2;\n}\n";
styleInject(css_248z$1);

var css_248z = "\n.rc-select-dropdown-hidden {\n    display: none;\n}\n.rc-select-dropdown {\n    border: 2px solid rgba(105,97,88,0.4);\n    box-sizing: border-box;\n    border-radius: 8px;\n    background: #ffffff;\n    z-index: 1080;\n    overflow: hidden;\n}\n.rc-select-item {\n    background: #ffffff;\n    padding: 8px 16px;\n    cursor: pointer;\n}\n.rc-select-item-option-selected {\n    background: #F1F3F4;\n}\n.rc-select-item-option-active {\n    background: rgba(241, 243, 244, 0.5);\n}\n\n/**\n * animation\n **/\n\n.rc-select-dropdown-slide-up-enter,\n.rc-select-dropdown-slide-up-appear {\n    animation-duration: 0.2s;\n    animation-fill-mode: both;\n    transform-origin: 0 0;\n     opacity: 0;\n     animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);\n     animation-play-state: paused;\n }\n\n.rc-select-dropdown-slide-up-leave {\n    animation-duration: 0.2s;\n    animation-fill-mode: both;\n    transform-origin: 0 0;\n     opacity: 1;\n     animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);\n     animation-play-state: paused;\n }\n\n.rc-select-dropdown-slide-up-enter.rc-select-dropdown-slide-up-enter-active.rc-select-dropdown-placement-bottomLeft,\n.rc-select-dropdown-slide-up-appear.rc-select-dropdown-slide-up-appear-active.rc-select-dropdown-placement-bottomLeft {\n     animation-name: rcSelectDropdownSlideUpIn;\n     animation-play-state: running;\n }\n\n.rc-select-dropdown-slide-up-leave.rc-select-dropdown-slide-up-leave-active.rc-select-dropdown-placement-bottomLeft {\n     animation-name: rcSelectDropdownSlideUpOut;\n     animation-play-state: running;\n }\n\n.rc-select-dropdown-slide-up-enter.rc-select-dropdown-slide-up-enter-active.rc-select-dropdown-placement-topLeft,\n.rc-select-dropdown-slide-up-appear.rc-select-dropdown-slide-up-appear-active.rc-select-dropdown-placement-topLeft {\n     animation-name: rcSelectDropdownSlideDownIn;\n     animation-play-state: running;\n }\n\n.rc-select-dropdown-slide-up-leave.rc-select-dropdown-slide-up-leave-active.rc-select-dropdown-placement-topLeft {\n     animation-name: rcSelectDropdownSlideDownOut;\n     animation-play-state: running;\n }\n \n \n@keyframes rcSelectDropdownSlideUpIn {\n    0% {\n        opacity: 0;\n        transform-origin: 0% 0%;\n        transform: scaleY(0);\n    }\n    100% {\n        opacity: 1;\n        transform-origin: 0% 0%;\n        transform: scaleY(1);\n    }\n}\n@keyframes rcSelectDropdownSlideUpOut {\n    0% {\n        opacity: 1;\n        transform-origin: 0% 0%;\n        transform: scaleY(1);\n    }\n    100% {\n        opacity: 0;\n        transform-origin: 0% 0%;\n        transform: scaleY(0);\n    }\n}\n@keyframes rcSelectLoadingIcon {\n    0% {\n        transform: rotate(0);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n";
styleInject(css_248z);

const GlobalStyle = ({
  children
}) => {
  setToSessionStorage('all-themes', primaTheme);
  const GlobalStyles = createGlobalStyle(["", " ", " ", " ", " ", ""], css_248z$5, css_248z$4, css_248z$3, css_248z$2, css_248z$1);
  const {
    theme,
    themeLoaded
  } = useTheme();
  return themeLoaded && /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(GlobalStyles, null), children);
};
GlobalStyle.propTypes = {
  children: PropTypes.node.isRequired
};

export { GlobalStyle };
